import { emptyClientProduct } from 'pages/ProductManagement/consts';
import { NON_VISIBLE_FIELDS } from 'shared/const';

/**
 * It takes an array of products, and for each product, it takes the key/value from the
 * "other" object and adds them to the product object
 * @param products - products whose custom fields may be stored under "other"
 * @returns An array of objects with the key other removed.
 */
const processOtherColumn = <T extends Record<string, unknown>>(products: T[]): Record<string, unknown>[] => {
    return products.map((product) => {
        const newProduct: Record<string, unknown> = { ...product };

        if (typeof newProduct.other === 'object' && newProduct.other != null) {
            Object.entries(newProduct.other).forEach(([key, value]) => {
                newProduct[key] = value;
            });

            delete newProduct.other;
        }

        return newProduct;
    });
};

const isCustomField = (field: string) => {
    return emptyClientProduct[field] == null && !NON_VISIBLE_FIELDS.includes(field) && !field.includes('name_');
};

export { processOtherColumn, isCustomField };
